import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'gpByte'
})
export class ByteConverterPipe implements PipeTransform {

  private digitalUnits: string[] = [
    'b', 'kb', 'mb', 'gb', 'tb'
  ];

  public transform(value: number, ...args: any[]): any {
    return this.getConvertValue(value);
  }

  private getConvertValue(value: number, unitIndex: number = 0) {
    if (value < 1024) {
      return `${value} ${this.digitalUnits[unitIndex]}`;
    }

    return this.getConvertValue((Math.round(value / 1024 * 100) / 100), ++unitIndex);
  }
}
